import React, {useState} from 'react';
import {Col, Row, Select} from 'antd';
import ENDPOINTS from '../../../../constants/endpoints';
import useDefaultRequest from '../../../../hooks/useDefaultRequest';
import ReportChartCard from '../../../../components/admin/reports/ReportChartCard';
import HorizontalBarChart from '../../../../components/admin/reports/charts/HorizontalBarChart';
import TimeSeriesLineChart from '../../../../components/admin/reports/charts/TimeSeriesLineChart';
import KpiStatRow from '../../../../components/admin/reports/charts/KpiStatRow';
import {dateFormat, moneyMask} from '../../../../utils/utils';

const GROUP_BY_OPTIONS = [
    {value: 'day', label: 'Dia'},
    {value: 'week', label: 'Semana'},
    {value: 'month', label: 'Mês'},
];
const PERIOD_FORMAT = {day: 'DD/MM', week: 'DD/MM', month: 'MMM/YY'};

export default function DiscountsSection({dateFrom, dateTo}) {
    const [groupBy, setGroupBy] = useState('day');
    const {data, isLoading} = useDefaultRequest({
        url: ENDPOINTS.REPORTS_ECOMMERCE_DISCOUNTS,
        params: {date_from: dateFrom, date_to: dateTo, group_by: groupBy},
        dataDefault: {},
    });
    const byState = data?.by_state || [];
    const byPeriod = data?.by_period || [];

    return (
        <>
            <div style={{marginBottom: 16}}>
                <KpiStatRow
                    loading={isLoading}
                    items={[
                        {title: '% Pedidos com Desconto', value: data?.percentage_with_discount ?? 0, precision: 2, suffix: '%'},
                        {title: 'Total em Descontos', value: data?.total_discount_value ?? 0, formatter: (v) => `R$ ${moneyMask(v)}`},
                        {title: 'Pedidos com Desconto', value: data?.orders_with_discount ?? 0},
                        {title: 'Total de Pedidos', value: data?.total_orders ?? 0},
                    ]}
                />
            </div>
            <Row gutter={[16, 0]}>
                <Col xs={24} lg={12}>
                    <ReportChartCard title="Descontos por Estado" loading={isLoading} isEmpty={!byState.length}>
                        <HorizontalBarChart
                            data={byState}
                            dataKey="total_discount"
                            nameKey="state"
                            valueFormatter={(v) => `R$ ${moneyMask(v)}`}
                            tooltipFields={[
                                {key: 'total_discount', label: 'Total Desconto', formatter: (v) => `R$ ${moneyMask(v)}`},
                                {key: 'orders', label: 'Pedidos'},
                            ]}
                        />
                    </ReportChartCard>
                </Col>
                <Col xs={24} lg={12}>
                    <ReportChartCard
                        title="Descontos por Período"
                        loading={isLoading}
                        isEmpty={!byPeriod.length}
                        extra={<Select value={groupBy} onChange={setGroupBy} options={GROUP_BY_OPTIONS} size="small" style={{width: 110}}/>}
                    >
                        <TimeSeriesLineChart
                            data={byPeriod}
                            dataKey="discount_total"
                            type="area"
                            periodFormatter={(v) => dateFormat(v, PERIOD_FORMAT[groupBy])}
                            valueFormatter={(v) => `R$ ${moneyMask(v)}`}
                            tooltipFields={[
                                {key: 'discount_total', label: 'Total Desconto', formatter: (v) => `R$ ${moneyMask(v)}`},
                                {key: 'discount_orders', label: 'Pedidos c/ Desconto'},
                                {key: 'total_orders', label: 'Total Pedidos'},
                            ]}
                        />
                    </ReportChartCard>
                </Col>
            </Row>
        </>
    );
}
